import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../../api/ApiCall";

export const updateBulkDrawings = createAsyncThunk(
  "updateBulkDrawings",
  async (data) => {
    const request = await api(`api/admin/drawings/edit`, data, "post");
    return request;
  }
);

export const listDrawings = createAsyncThunk(
  "listDrawings",
  async ({ search = "", page = 1, limit = 10, sortBy, sortOrder }) => {
    const request = await api(
      `api/admin/drawings?search=${search}&page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      "",
      "get"
    );
    return request;
  }
);

export const deleteDrawing = createAsyncThunk(
  "deleteDrawing",
  async ({ id }) => {
    const request = await api(`api/admin/drawing/${id}`, {}, "delete");
    return request;
  }
);

export const searchDrawings = createAsyncThunk(
  "searchDrawings",
  async ({ customer_id, drawing_status, date_required, requested_by, designer_id, page, limit, sortBy, sortOrder }) => {
    const request = await api(
      `api/admin/searchdrawings?customer_id=${customer_id}&drawing_status=${drawing_status}&date_required=${date_required}&requested_by=${requested_by}&designer_id=${designer_id}&page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      "",
      "get"
    );
    return request;
  }
);

export const listDrawingsByOpportunity = createAsyncThunk(
  "listDrawingsByOpportunity",
  async ({ opportunity_id, search = "", page = 1, limit = 10 }) => {
    const request = await api(
      `api/admin/drawingbyopportunity/${opportunity_id}?search=${search}&page=${page}&limit=${limit}`,
      "",
      "get"
    );
    return request;
  }
);

export const getDrawingById = createAsyncThunk(
  "getDrawingById",
  async (data) => {
    const request = await api(`api/admin/drawing/${data}`, "", "get");
    return request;
  }
);

export const getDrawingByOpportunityForUI = createAsyncThunk(
  "getDrawingByOpportunityForUI",
  async (data) => {
    const request = await api(`api/admin/drawingbyopportunityforui/${data}`, "", "get");
    return request;
  }
);

export const getCustomerForUI660 = createAsyncThunk(
  "getCustomerForUI660",
  async () => {
    const request = await api(`api/app/customers660`, "", "get");
    return request;
  }
);

export const getOpportunityByCustomerId660 = createAsyncThunk(
  "getOpportunityByCustomerId660",
  async (data) => {
    const request = await api(`api/app/opportunities660/${data}`, "", "get");
    return request;
  }
);

export const getDrawingByOpportunityFor660 = createAsyncThunk(
  "getDrawingByOpportunityFor660",
  async (data) => {
    const request = await api(`api/app/get-drawing/${data}`, "", "get");
    return request;
  }
);

export const addExpenseSnags = createAsyncThunk(
  "addExpenseSnags",
  async (data) => {
    const request = await api("api/app/add-expense-snags", data,"postFile");
    return request;
  }
);

export const getExpenseSnags = createAsyncThunk(
  "getExpenseSnags",
  async ({customer_id,page,limit}) => {
    const request = await api("api/app/list-expense-snags/?customer_id="+customer_id+"&page="+page+"&limit="+limit+"", "","get");
    return request;
  }
);

export const deleteExpenseSnag = createAsyncThunk(
  "deleteExpenseSnag",
  async (data) => {
    const request = await api(`api/app/del-expense-snags/${data}`, "", "get");
    return request;
  }
);

export const delExpensePhoto = createAsyncThunk(
  "delExpensePhoto",
  async (data) => {
    const request = await api(`api/app/del-expense-photo/${data}`, "", "get");
    return request;
  }
);

export const getSingleSnags = createAsyncThunk(
  "getSingleSnags",
  async (data) => {
    const request = await api(`api/app/get-expense-snags/${data}`, "", "get");
    return request;
  }
);

export const editExpenseSnags = createAsyncThunk(
  "editExpenseSnags",
  async (data) => {
    const request = await api("api/app/edit-expense-snags", data,"postFile");
    return request;
  }
);

export const getMaterialListByDrawing = createAsyncThunk(
  "getMaterialListByDrawing",
  async (data) => {
    const request = await api(`api/admin/materiallistbydrawing/${data}`, "", "get");
    return request;
  }
);


export const addDrawing = createAsyncThunk("addDrawing", async (data) => {
  const request = await api("api/admin/drawing", data, "post");
  return request;
});

export const updateDrawing = createAsyncThunk(
  "updateDrawing",
  async ({ data, id }) => {
    const request = await api(`api/admin/drawing/${id}`, data, "post");
    return request;
  }
);

export const updateDrawingStatus = createAsyncThunk(
  "updateDrawingStatus",
  async ({ data, id }) => {
    const request = await api(`api/admin/drawing/updatestatus/${id}`, data, "post");
    return request;
  }
);

export const copyDrawing = createAsyncThunk(
  "copydrawing",
  async (drawing_id) => {
    const request = await api(`api/admin/copydrawing/${drawing_id}`, "", "get");
    return request;
  }
);

export const toggleDrawinglock = createAsyncThunk(
  "toggledrawinglock",
  async (drawing_id) => {
    const request = await api(`api/admin/toggledrawinglock/${drawing_id}`, "", "get");
    return request;
  }
);

export const getDrawingLockStatus = createAsyncThunk(
  "getdrawinglockstatus",
  async (drawing_id) => {
    const request = await api(`api/admin/getdrawinglockstatus/${drawing_id}`, "", "get");
    return request;
  }
);

const drawingSlice = createSlice({
  name: "drawing",
  initialState: {
    loading: false,
    drawings: [],
    success: null,
    error: null,
    totalCount: 0,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(listDrawingsByOpportunity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listDrawingsByOpportunity.fulfilled, (state, action) => {
        state.drawings = action?.payload?.rows;
        state.totalCount = action?.payload.count;
        state.loading = false;
        state.error = null;
      })
      .addCase(listDrawingsByOpportunity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(listDrawings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listDrawings.fulfilled, (state, action) => {
        state.drawings = action?.payload?.rows;
        state.totalCount = action?.payload.count;
        state.loading = false;
        state.error = null;
      })
      .addCase(listDrawings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(searchDrawings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchDrawings.fulfilled, (state, action) => {
        state.drawings = action?.payload?.rows;
        state.totalCount = action?.payload.count;
        state.loading = false;
        state.error = null;
      })
      .addCase(searchDrawings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addDrawing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDrawing.fulfilled, (state, action) => {
        state.loading = false;
        state.drawings = action.payload;
        state.error = null;
      })
      .addCase(addDrawing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateDrawing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDrawing.fulfilled, (state, action) => {
        state.loading = false;
        state.drawings = state.drawings.map((option) => {
          if (option.id === action.payload.id) {
            return action.payload;
          }
          return option;
        });
        state.success = action.payload.message;
        state.error = null;
      })
      .addCase(updateDrawing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateBulkDrawings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBulkDrawings.fulfilled, (state, action) => {
        state.loading = false;
        state.drawings = action.payload?.drawings;
        state.error = null;
      })
      .addCase(updateBulkDrawings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default drawingSlice.reducer;
